import AxiosFactory from '@/entities/security/AxiosFactory'

class GlobalApi {
  async getStripeIntentToken() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get('/api/v1/user/payment/setup-intent')
      return response
    } catch (e) {
      console.log('getStripeIntentToken error: ', e)
      // throw ApiErrorFactory.create(e);
    }
  }

  async getGlobalPaymentMethods() {
    try {
      const response = await AxiosFactory.createAxiosInstance().get('/api/v1/configuration/payment-gateways')
      return response
    } catch (e) {
      console.log('getGlobalPaymentMethods error: ', e)
      // throw ApiErrorFactory.create(e);
    }
  }
}

export default new GlobalApi()
